import { Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  constructor() { }
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
      return true;
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/privacy/privacy.component.ts